import { z } from "zod";
import { MetaSchema } from "./shared";
import { PolicyEnum } from "../enums";
export const RewardPolicySchema = z.object({
  id: z.string().uuid(),
  name: PolicyEnum.PolicyTypesSchema,
  percentProfit: z.number(),
  type: z.string(),
  status: z.string(),
  minAmount: z.number().nullable(),
});

export const RewardUserSchema = z.object({
  id: z.string().uuid(),
  uuid: z.string(),
  isActivePlan: z.boolean(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  gender: z.string().nullable(),
  role: z.string(),
  rank: z.string(),
  username: z.string(),
  email: z.string().nullable(),
  avatar: z.string(),
  activatedPlanAt: z.string().datetime(),
  createdAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable(),
});

export const UserRewardItemSchema = z.object({
  id: z.string().uuid(),
  description: z.string(),
  fromWallet: z.string(),
  rewardAmount: z.string(),
  rewardedAt: z.string().datetime(),
  createdAt: z.string().datetime(),
  user: RewardUserSchema,
  policy: RewardPolicySchema,
  fromUID: z.string(),
});
export const RewardSummarySchema = z.object({
  total: z.number(),
});
export const UsersRewardsDataSchema = z.tuple([
  z.array(UserRewardItemSchema),
  z.number(),
  RewardSummarySchema,
]);
const UsersRewardsResponse = z.object({
  data: UsersRewardsDataSchema,
  meta: MetaSchema.default,
});

export type UserRewardItemSchemaType = z.infer<typeof UserRewardItemSchema>;
export type UsersRewardsResponseType = z.infer<typeof UsersRewardsResponse>;

export default UsersRewardsResponse;
